var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-body",attrs:{"id":"bottom-body"}},[_c('ml-table',{attrs:{"columns":_vm.columns,"data-source":_vm.dataSource,"scroll":{ y: _vm.scrollY }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }